import APIConstants from "./APIConstants";
import APIService from "./APIService";
import DebugService from "./DebugService";

/**
 * @description Appointment Booking Api Service
 */
const AppointmentBookingApiService = {
  // Appointment booking
  submit: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_APPOINTMENT_BOOKING, data)
    } catch (err) {
      DebugService.error('Appointment Booking Api Service: Caught error while submitting', err)
    }
  },

  // Get all appointment booking list
  getList: async (data) => {
    try {
      let endpoint = APIConstants.ENDPOINT_APPOINTMENT_BOOKING_LIST

      if (data !== undefined && data['filters'] !== undefined && data['filters']['status'] !== undefined) {
        endpoint = `${endpoint}?status=${data['filters']['status']}`
      }

      return await APIService.get(endpoint)
    } catch (err) {
      DebugService.error('Appointment Booking Api Service: Caught error while fetching', err)
    }
  },

  /**
   * Get all booked time slots
   * @param {*} data 
   * @returns 
   */
  getBookedTimeSlots: async (data) => {
    try {
      let endpoint = APIConstants.ENDPOINT_APPOINTMENT_BOOKED_TIME_SLOTS

      if (data !== undefined && data['filters'] !== undefined && data['filters']['startTime'] !== undefined) {
        endpoint = `${endpoint}?startTime=${data['filters']['startTime']}`
      }

      return await APIService.get(endpoint)
    } catch (err) {
      DebugService.error('Appointment Booking Api Service: Caught error while fetching booked time slots', err)
    }
  },

  /**
   * Get available time period for creating available time slots
   * @param {*} data 
   * @returns 
   */
  getAvailableTimePeriod: async (data) => {
    try {
      let endpoint = APIConstants.ENDPOINT_APPOINTMENT_AVAILABLE_TIME_PERIOD

      if (data !== undefined && data['filters'] !== undefined && data['filters']['startTime'] !== undefined) {
        endpoint = `${endpoint}?startTime=${data['filters']['startTime']}`
      }

      return await APIService.get(endpoint)
    } catch (err) {
      DebugService.error('Appointment Booking Api Service: Caught error while fetching available time period', err)
    }
  },

  /**
   * Save available time period
   * @param {*} data 
   * @returns 
   */
  saveTimeAvailability: async (data) => {
    try {
      return await APIService.post(`${APIConstants.ENDPOINT_APPOINTMENT_AVAILABLE_TIME_PERIOD}`, data)
    } catch (err) {
      DebugService.error('Appointment Booking Api Service: Caught error while saving appointment booking available time', data, err)
    }
  },

  /**
   * Mark the requested appointment booking data as "Completed"
   * @param {*} data 
   * @param {*} id Appointment booking Id
   * @returns 
   */
  update: async (data, id) => {
    try {
      return await APIService.put(`${APIConstants.ENDPOINT_APPOINTMENT_BOOKING}/${id}`, data)
    } catch (err) {
      DebugService.error('Appointment Booking Api Service: Caught error while updating appointment booking details', data, err)
    }
  },
};

export default AppointmentBookingApiService;
